import { auth } from '../types'

const INITIAL_STATE = {
    error: undefined,
    tab: "service"
}

const authreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case auth.GET_REGISTER_MOBILE_SUCCESS:
            return {
                ...state,
                otp: {data : action.payload , message : "registerwithmobilenumber"}
            }
        case auth.GET_OTP_SUCCESS:
            return{
                ...state,
                otp:{data : action.payload , message : "loginwithmobilenumber"}
              }    
        case auth.GET_REGISTER_MOBILE_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        case auth.AUTH_ERROR_REQUEST:
            return {
                ...state,
                error: action.payload
            }
        case auth.RESET_AUTH_STORE_SUCCESS:
            return INITIAL_STATE

        case auth.SET_TAB_SERVICE:
            return {
                ...state,
                tab: action.payload
            }

        case auth.GET_OTP_FAILURE :
                return {
                    ...state,
                    error: action.payload
                }
               
        default :
            return state    
        }
}

export default authreducer